import {Alert, Button, Pagination, Table, Tag, TextInput} from "omoplay";
import {getProductList, productRegistration} from "../../api/product/product.api";
import React, {useEffect, useState} from "react";
import moment from "moment";
import SuspensePopup from "../SuspensePopup";
import AICreditIcon from "../../assets/images/icon.credit.svg"
import {getTier} from "../../api/account/account.api";
import GenericBoard from "../form/GenericBoard";

const ProductList = () => {
    const [url, setUrl] = useState("")
    const [products, setProducts] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [showRegister, setShowRegister] = useState(false)
    const [registrationMaxLength, setRegistrationMaxLength] = useState("")
    const [page, setPage] = useState(1)

    const headers = [
        { name: "제품명" }, { name: "카테고리", width: "150px", align: "center" }, { name: "제품 코드", width: "150px", align: "center" },
        { name: "소비자가", width: "130px", align: "center" }, { name: "채널명", width: "160px", align: "center" },
        { name: "생성 날짜", width: "130px", align: "center" }, { name: "상태", width: "120px", align: "center" }
    ]

    useEffect(() => {
        getProductList(null, null, page).then(({data}) => {
            setTotalCount(data.second)
            setProducts(data.first.map(product => {
                const info = product.info ?? { images: []}
                return [
                    <div className="flex-align-center pointer gap-2 text-primary" onClick={() => {
                        window.location.href = `/product/detail?id=${product.id}`
                    }}>
                        <div><img width={60} height={60} src={info.images[0]} /></div>
                        <div>{info.productName}</div>
                    </div>,
                    <div className="flex-center-all h-full"><Tag>{info.category}</Tag></div>,
                    <div className="flex-center-all h-full">{info.price}</div>,
                    <div className="flex-center-all h-full">{info.siteName}</div>,
                    <div className="flex-center-all h-full text-center">{moment(product.createdAt).format("YYYY-MM-DD HH:mm:ss")}</div>,
                    <div className="flex-center-all h-full">{
                        product.isValid ? <Tag color="info">사용 가능</Tag> :
                            ( product.info ? <Tag color="error">사용 불가</Tag> : <Tag color="warning">불러오는 중</Tag>)}
                    </div>
                ]
            }))
        })
        setRegistrationMaxLength("무제한")
    }, [page]);

    function registration() {
        if (url !== "") {
            productRegistration(url).then(({data}) => {
                if (data === "insufficient") {
                    alert("크레딧이 부족합니다.")
                } else if (data === "exceeded") {
                    alert("등록할 수 있는 최대 개수를 초과했습니다.")
                } else {
                    alert("자동 등록을 호출 했습니다. 완료되면 상품이 등록됩니다.")
                    window.location.reload()
                }
            })
        }
    }

    return (
        <>
            <div className="flex-col gap-2">
                <div className="flex-align-center justify-between">
                    <div className="font-semibold">
                        전체: <span className="text-primary ">{totalCount}개</span> / {registrationMaxLength}
                    </div>
                    <Button variants="ai" value="+ AI로 제품 추가하기" onClick={() => setShowRegister(true)} />
                </div>
                <GenericBoard items={products} columns={[
                    { align: 'left', flex: true },
                    { align: 'right' },
                    { align: 'right' },
                    { align: 'right' },
                    { align: 'right' },
                    { align: 'right' }
                ]} />
                <div className="flex-center-all">
                    <Pagination currentPage={page} pageSize={10} totalCount={totalCount} onPaging={setPage} />
                </div>
            </div>
            <SuspensePopup title="URL로 제품 등록하기"
                           visible={showRegister}
                           onClose={() => setShowRegister(false)}>
                <div className="flex-col gap-2">
                    <div className="w-full flex-1">
                        <TextInput placeholder="제품 상세페이지가 있는 URL을 입력하세요."
                                   onChange={(e) => setUrl(e.target.value)} />
                    </div>
                    <div className="flex justify-end w-full">
                        <Button variants="secondary" disabled={url === "" || !url.includes("http")}
                                value={<div className="flex">AI로 제품 추가하기 (<div><img src={AICreditIcon} alt="ai_credit" /></div>50 Credit 차감)</div>}
                                onClick={() => registration()} />
                    </div>
                    <Alert title="유의사항" type="warning">
                        <div>
                            <li>제품 정보를 가지고 오는데에는 약 1~3분이 소요됩니다.</li>
                            <li>제품 정보를 가지고 온 이후에도 필수 항목은 추가로 수기 입력이 필요할 수 있습니다.</li>
                            <li>URL 혹은 사이트가 올바르지 않은 경우 불러오지 못할 수 있습니다.</li>
                            <li>상품을 불러오지 못한 경우 크레딧은 환불 됩니다.</li>
                        </div>
                    </Alert>
                </div>
            </SuspensePopup>
        </>
    );
};

export default ProductList;
